import {Component, OnInit} from '@angular/core';
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {HeroSectionComponent} from "../hero-section/hero-section.component";
import {HeroServiciosComponent} from "./hero-servicios/hero-servicios.component";
import {ServicesListComponent} from "./services-list/services-list.component";
import {FooterComponent} from "../../footer/footer.component";
import {FloatButtonComponent} from "../../float-button/float-button.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";

@Component({
  selector: 'app-servicios-person',
  standalone: true,
    imports: [
        NavBarComponent,
        HeroSectionComponent,
        HeroServiciosComponent,
        ServicesListComponent,
        FooterComponent,
        FloatButtonComponent,
        FooterPersonaComponent
    ],
  templateUrl: './servicios-person.component.html',
  styleUrl: './servicios-person.component.css'
})
export class ServiciosPersonComponent {

  }
